import { render, staticRenderFns } from "./OperateDialog.vue?vue&type=template&id=60b79326&scoped=true&"
import script from "./OperateDialog.vue?vue&type=script&lang=js&"
export * from "./OperateDialog.vue?vue&type=script&lang=js&"
import style0 from "./OperateDialog.vue?vue&type=style&index=0&id=60b79326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b79326",
  null
  
)

export default component.exports